import React from 'react';
import { Phone } from 'lucide-react';
export function TrustSection() {
  return <section className="bg-white py-10 lg:py-12 border-b border-gray-100" data-id="element-131">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">
        <div className="bg-white rounded-xl p-6 lg:p-10 shadow-sm border border-gray-100 flex flex-col lg:flex-row items-center justify-between gap-6 text-center lg:text-left" data-id="element-133">
          <div className="flex-1" data-id="element-134">
            <h2 className="text-xl lg:text-2xl font-bold text-gray-900 mb-2" data-id="element-135">
              Get a FREE membership &{' '}
              <span className="text-[#9fd23d]" data-id="element-136">SAVE</span> up to{' '}
              <span className="text-[#9fd23d] text-3xl lg:text-4xl font-extrabold" data-id="element-137">
                25%
              </span>{' '}
              on ALL products!
            </h2>
            <p className="text-sm text-gray-500" data-id="element-138">
              Join thousands of satisfied customers who trust NeoLife for their
              daily nutrition.
            </p>
          </div>

          <div className="flex-shrink-0 bg-gray-50 py-4 px-6 rounded-lg border border-gray-100" data-id="element-139">
            <p className="text-xs text-gray-500 font-medium mb-1 text-center" data-id="element-140">
              Any questions?
            </p>
            <a href="tel:800-260-2808" className="flex items-center justify-center text-xl lg:text-2xl font-bold text-[#0e7be1] hover:underline" data-id="element-141">
              <Phone className="h-5 w-5 mr-2" data-id="element-142" />
              800-260-2808
            </a>
          </div>
        </div>
      </div>
    </section>;
}